//import _ from "lodash"
//import router from '../../router'
import { eventService } from '../../services'

// initial state
const state = () => ({
  events: [],
  event: null,
  activeEvent: null,
  eventTemplates: null
})

// actions
const actions = {
  getEvents({ commit }) {
    eventService.getEvents().then(
      (events) => {
        commit('getEventsSuccess', events)
      },
      (error) => {
        commit('getEventsFailure', error)
      }
    )
  },
  getEvent({ commit }, eventId) {
    eventService.getEvent(eventId).then(
      (event) => {
        commit('getEventSuccess', event)
      },
      (error) => {
        commit('getEventFailure', error)
      }
    )
  },
  createEvent({ commit, dispatch }, eventData) {
    eventService.createEvent(eventData).then(
      (event) => {
        commit('createEventSuccess', event)
        dispatch('getEvents')
      },
      (error) => {
        commit('getEventFailure', error)
      }
    )
  },
  createEventFromTemplate({ commit }, eventData) {
    return eventService.createEventFromTemplate(eventData).then(
      (data) => {
        if (data.errors) {
          commit('getEventFailure', data.errors)
        } else {
          commit('createEventSuccess', data.created.value.event)
          commit('setActive', data.created.value.event)
        }
        return JSON.parse(JSON.stringify(data))
      },
      (error) => {
        commit('getEventFailure', error)
      }
    )
  },
  copyEvent({ commit }, { eventId, eventData }) {
    eventService.copyEvent(eventId, eventData).then(
      (event) => {
        commit('createEventSuccess', event)
      },
      (error) => {
        commit('getEventFailure', error)
      }
    )
  },
  updateEvent({ commit, dispatch }, { eventId, eventData }) {
    eventService.updateEvent(eventId, eventData).then(
      (event) => {
        commit('getEventSuccess', event)
        dispatch('getEvents')
      },
      (error) => {
        commit('getEventFailure', error)
      }
    )
  },
  deleteEvent({ commit, dispatch }, eventId) {
    eventService.deleteEvent(eventId).then(
      (event) => {
        commit('deleteEventSuccess', event.id)
        dispatch('getEvents')
      },
      (error) => {
        commit('getEventFailure', error)
      }
    )
  },
  setActiveEvent({ commit }, event) {
    commit('setActive', event)
  },
  removeActiveEvent({ commit }) {
    commit('removeActive')
  },
  getEventTemplates({ commit }) {
    eventService.getEventTemplates().then(
      (templates) => {
        commit('getEventTemplatesSuccess', templates)
      },
      (error) => {
        commit('getEventTemplatesFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getEventsSuccess(state, events) {
    state.events = events
  },
  getEventSuccess(state, event) {
    state.event = event
  },
  getEventsFailure(state, error) {
    console.log(state, error)
  },
  createEventSuccess(state, event) {
    state.events.push(event)
  },
  deleteEventSuccess(state, eventId) {
    let index = state.events.findIndex((event) => event.id == eventId)
    state.events.splice(index, 1)
  },
  setActive(state, event) {
    state.activeEvent = event
  },
  removeActive(state) {
    state.activeEvent = null
  },
  getEventTemplatesSuccess(state, event) {
    state.eventTemplates = event
  },
  getEventTemplatesFailure(state, error) {
    console.log(state, error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
